export class Setting {
    setting_id ?= '';
    setting_name ?= '';
    setting_code ?= '';
    setting_value ?= '';
}


// WEBPACK FOOTER //
// ./src/app/type/setting.ts